<template>
<div id="app">
    <router-view />
    <globalLoading v-show="isLoading==true" />
    <payModalWarnModal :accountInfo="accountInfo" />
    <previewDialog></previewDialog>
    <!-- 选择课程弹框 -->
    <chooseCourseModal :userInfo="userInfo"></chooseCourseModal>
    <!-- 订单详情 -->
    <orderModal></orderModal>
</div>
</template>

<script>
// 支付提示弹框
import payModalWarnModal from "@/view/pay/components/pay-warn-modal.vue";

import CryptoJS from 'crypto-js'; // 加密

// 预览图片
import previewDialog from "@/view/course/components/previewImage/previewDialog";

// 选择商品
import chooseCourseModal from '@/view/course/components/course/choose-course';

// 订单详情弹框
import orderModal from "@/view/order/components/detailModal";

import {
    getLocalStorage,
    getToken,
    removeToken,
    clearLocalStorage,
    saveLocalStorage,
    removeLocalStorage
} from '@/utils/auth'
import {
    getCookie
} from "@/utils/index"
import globalLoading from './zsm-layout/components/Settings/loading' // 全局加载样式
export default {
    name: 'App',
    components: {
        payModalWarnModal,
        globalLoading,
        previewDialog,
        chooseCourseModal,
        orderModal
    },
    data() {
        return {
            accountInfo: ''
        }
    },
    computed: {
        userInfo() {
            if (this.$store.state['zsm-user'].userInfo) {
                return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
            } else {
                return JSON.parse(JSON.parse(getLocalStorage('zsm-userInfo')))
            }
        },
        isLoading() {
            return this.$store.state['app'].isLoading
        },
        theme() {
            return this.$store.state['zsm-setting'].theme
        },
        examplesImage() {
            return this.$store.state['zsm-dict'].examplesImage
        },
        examplesModal() {
            return this.$store.state['zsm-dict'].examplesModal
        },
        platformDict() {
            return this.$store.state['zsm-user'].platformDict
        },
        douyinPlatFormDict() {
            return this.$store.state['zsm-user'].douyinPlatFormDict
        },
        routePath(path) {
            return this.$route.path
        }
    },
    watch: {
        // 抖店平台
        douyinPlatFormDict(type) {
            this.setAttribute(type)
        },
        // 抖店平台
        routePath(route) {
            // 无需校验的页面
            let noPromiseUrl = [
                "/tutorial/detail",
                "/tutorial/index",
                "/login",
                "/agent",
                "/agreement",
                "/question",
                '/',
                '/user',
                '/fund/withdraw',
                '/pay',
                '/pay/index',
                '/fund/account/alipay',
                '/fund/withdrawal-record'
            ]
            if (noPromiseUrl.indexOf(this.$route.path) == -1) {
                this.getAccount()
            }
            this.$store.commit('zsm-good/clearChooseGood');

        },
    },
    mounted() {
        this.getAccount()
        this.serviceInit();
        this.setAttribute(this.douyinPlatFormDict);
        removeLocalStorage('zsm_tips_warn_status');
        removeLocalStorage('zsm_upload_pc_course_tutorial');
    },
    beforeMount() {
        this.$nextTick(() => {
            this.$store.state['zsm-dict'].examplesModal = false;
            this.$store.commit('app/CHANGEISLOADING', false) // 加载框隐藏
        });
        this.listenPage();
    },
    onUpdated() {
        this.getAccount()
    },
    methods: {
        /**
         * 获取账号信息
         * @param {*} id 
         * @returns 
         */
        async getAccount() {
            let expire = getCookie('expire');
            if (getLocalStorage('zsm-mobile') && this.userInfo) {
                if (!expire || new Date(expire).getTime() < new Date().getTime()) {
                    let res = await this.$store.dispatch('zsm-user/getAccount', this.userInfo.mobile);
                    if (new Date(expire).getTime() < new Date().getTime()) {
                        this.$store.state['zsm-pay'].payModalWarnFlag = true;
                        this.accountInfo = res;
                    }
                    if (!res) {
                        this.$store.dispatch('zsm-user/accountLogout', getLocalStorage('zsm-mobile'))
                        this.$router.replace('/login');
                        this.$message.error('账号有误，请重新登录！')
                        this.$store.state['zsm-pay'].payModalWarnFlag = false;
                    }
                }
            }
        },
        // 客服初始化
        serviceInit() {
            (function (m, ei, q, i, a, j, s) {
                m[i] = m[i] || function () {
                    (m[i].a = m[i].a || []).push(arguments)
                };
                j = ei.createElement(q),
                    s = ei.getElementsByTagName(q)[0];
                j.async = true;
                j.charset = 'UTF-8';
                j.src = 'https://static.meiqia.com/dist/meiqia.js';
                s.parentNode.insertBefore(j, s);
            })(window, document, 'script', '_MEIQIA');
            _MEIQIA('entId', 'f6202e7c1f44c964e3edfbdac7315ae4');
            // 在这里开启无按钮模式（常规情况下，需要紧跟在美洽嵌入代码之后）
            _MEIQIA('withoutBtn');
        },
        // 设置主题
        setAttribute(platformDict) {
            if (platformDict == 'douyin') {
                window.document.documentElement.setAttribute('data-theme', 'red')
            } else if (platformDict == 'doudian') {
                window.document.documentElement.setAttribute('data-theme', 'blue')
            } else if (platformDict == 'kuaishou') {
                window.document.documentElement.setAttribute('data-theme', 'orangered')
            } else if (platformDict == 'shipinhao') {
                window.document.documentElement.setAttribute('data-theme', 'green')
            } else if (platformDict == 'xiaohongshu') {
                window.document.documentElement.setAttribute('data-theme', 'xiaohongshu')
            } else {
                window.document.documentElement.setAttribute('data-theme', 'red')
            }
        },
        // 获取字典内容
        getSettingDict() {
            this.$store.dispatch('zsm-dict/settingDict', 'zsm_web_user_permission_dict').then(info => { // 知视猫--前端默认权限内容
                saveLocalStorage('zsm_web_user_permission_dict', info)
            })
        },
        // 监听页面跳转
        listenPage() {
            window.onbeforeunload = function (e) {
                if (this.$route && (!this.$route.path || (this.$route.path == '/tutorial/detail' || this.$route.path == '/tutorial/index' || this.$route.path ==
                        '/agreement' || this.$route.path == '/login'))) {} else {
                    if (!getLocalStorage('zsm-login') || !getLocalStorage('zsm-mobile') || !getLocalStorage('zsm-userInfo') ||
                        !getLocalStorage('zsm-versions')) {
                        if (this.$route.path !== '/login') {
                            removeToken('zsm-token')
                            this.$router.replace('/login')
                            clearLocalStorage()
                        }
                    }
                }
            }
        },
    }
}
</script>

<style>
.el-popover {
    border: none;
}
</style><style lang="scss">
@import "@/styles/variable-color.scss";

.commit-color {
    @include color_primary(bg_color_primary); //边框
}

.text-red {
    color: $text-red-warn
}

.driver-popover-footer {
    justify-content: flex-end;
    display: flex !important;
    width: 100% !important;
}

/*新手指引*/
.driver-btn-group {
    /*display: flex;*/
    /*width: 100%;*/
    padding-left: 0;
    /*justify-content: space-between;*/
}

.driver-popover-tip.left {
    /*top: 30px!important;*/
}

.driver-popover-tip {
    /*border:19px solid #fff!important;*/
}

div#driver-popover-item .driver-popover-tip.left {
    left: -22px !important;
    top: 28px !important;
    border: 12px solid transparent !important;
    border-right: 12px solid #fff !important;
}

div#driver-popover-item .driver-popover-tip.right {
    right: -22px !important;
    top: 28px !important;
    border: 12px solid transparent !important;
    border-left: 12px solid #fff !important;
}

/* 上一步按钮 */
.driver-prev-btn {
    display: none !important;
}

.driver-popover-description {
    font-size: 13px !important;
    margin-top: 8px;
}

/* 下一步按钮 */
.driver-next-btn {
    color: #fff !important;
    @include bg_color_primary(bg_color_primary_dark); //边框
    @include border_color_primary(bg_color_primary_dark); //背景色
    @include text-shadow_color_primary(bg_color_primary_dark); //阴影
    display: inline-block !important;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none !important;
    text-align: center !important;
    box-sizing: border-box !important;
    outline: none !important;
    transition: .1s !important;
    font-weight: 400 !important;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    width: 80px !important;
    /*height: 34px!important;*/
    line-height: 30px !important;
    font-family: SourceHanSansSC-regular;
    font-size: 14px !important;
    border-radius: 4px !important;
}

/* 关闭按钮 */
.driver-close-btn {
    width: 100% !important;
    text-align: left !important;
    border: none !important;
    background-color: #fff !important;
    float: none;
    font-family: SourceHanSansSC-regular;
    color: #CFCED5 !important;
    font-size: 16px !important;
    /*display: none !important;*/
}

/* 整体盒子样式 */
div#driver-popover-item {
    border-radius: 15px !important;
    max-width: 320px !important;
    width: 320px !important;
    padding: 20px 28px 30px 28px !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    margin: 0 15px !important;

    &.guide-navbar6 {
        margin-left: -20px !important;

        .driver-close-btn {
            display: none;
        }
    }
}

/*,.el-button--danger*/
/*.v-modal{*/
/*  display: block;*/
/*}*/
.el-button--primary {
    @include bg_color_primary(bg_color_primary_dark); //边框
    @include border_color_primary(bg_color_primary_dark); //背景色
    color: #fff !important;
    /* background-color: #ff4d6d !important;
                                                                   border-color: #ff4d6d !important;*/
}

.el-button--primary:active,
.el-button--primary.is-active,
.el-button--primary:hover {
    /*background-color: rgba(#ff4d6d,0.9) !important;*/
    /*border-color: rgba(#ff4d6d,0.9) !important;*/
    @include border_color_primary_dark_hover(border_color_primary_dark); //边框
    @include bg_color_primary_dark_hover(border_color_primary_dark); //背景
    color: #fff !important;
}

.back_top {
    @include color_primary(border_color_primary_dark); //边框
}

/*  .el-button--danger.is-disabled, .el-button--danger.is-disabled:hover, .el-button--danger.is-disabled:focus, .el-button--danger.is-disabled:active{
                                                                  @include border_color_primary_dark(border_color_primary_dark); //边框
                                                                  @include bg_color_primary_dark(border_color_primary_dark); //背景
                                                                  color: #fff!important;
                                                                }
                                                              .el-button--primary.is-disabled, .el-button--primary.is-disabled:hover, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:active{
                                                                @include border_color_primary_dark_hover(border_color_primary_dark); //边框
                                                                @include bg_color_primary_dark_hover(border_color_primary_dark); //背景
                                                                color: #fff!important;
                                                              }*/
.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active {
    @include bg_color_primary_dark_disabled(border_color_primary_dark); //边框
    border: none;
}

.examplesModalDialog {
    position: fixed !important;
    z-index: 8999 !important;
    background: rgba(0, 0, 0, 0.5);
}

.examplesModalDialog::v-deep .el-icon-close {
    font-size: 26px !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
    /*background-color: #ff4d6d !important;*/
    @include bg_color_primary(bg_color_primary_dark); //边框
}

.driver-popover-title {
    height: 48px;
}

/*table边框颜色*/
.el-table--border:after,
.el-table--group:after,
.el-table:before {
    background-color: #F1F1F1 !important;
}

.el-table--border,
.el-table--group {
    border-color: #F1F1F1;
}

.el-table td,
    {
    border-bottom: 1px solid #F1F1F1 !important;
}

/*.el-table th.is-leaf*/
.el-table--border th,
.el-table--border th.gutter:last-of-type {
    border-bottom: 1px solid #F1F1F1 !important;
}

.el-table--border td,
.el-table--border th {
    border-right: 1px solid #F1F1F1 !important;
}
</style>
